// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — oval-button.classic.js, новая — oval-button.cp.js
import { isCp } from 'libs/design';
import * as classic from './oval-button.classic';
import * as cp from './oval-button.cp';

export const BlackButton = isCp ? cp.BlackButton : classic.BlackButton;
export const BlueButton = isCp ? cp.BlueButton : classic.BlueButton;
export const GrayButton = isCp ? cp.GrayButton : classic.GrayButton;
export const GreenButton = isCp ? cp.GreenButton : classic.GreenButton;
export const OvalButton = isCp ? cp.OvalButton : classic.OvalButton;
export const RedButton = isCp ? cp.RedButton : classic.RedButton;
export const WhiteButton = isCp ? cp.WhiteButton : classic.WhiteButton;
